module.exports = __webpack_public_path__ + "img/breadcrumb3.5e35db8a.png";